import dayjs from 'dayjs'

export default class MilestoneBuilder {

	constructor(configOffset=null, configBlackout=null) {

		this.O = configOffset
		this.B = configBlackout

		this.P = {
			submit: { prop: 'date_submitted' },
			approval: { prop: 'date_approved' },
			first_comp: { prop: 'date_first_comp' },
			premedia: { prop: 'date_premedia' },
			print: { prop: 'date_release' },
			delivery: { prop: 'date_delivery' }
		}
	}

	getMilestones(dept, type, premedia=false, rush24hr=null, submitted=null) {

		let t = (this._getType( type ) === 'print') ? 'print' : 'nonprint' // print | everything else = non-print
		let d = (this._getDept( dept ) === 'international') ? 'international' : 'domestic'// international | everything else = domestic
		let p = premedia ? 'premedia' : 'nopremedia' // (p) premedia | (np) no premedia

		let dataString = `${t}${t === 'nonprint' ? '_'+d : ''}_${p}`
		let dataSet = this.O[dataString]

		let base = this._getMilestoneBase( t, premedia, rush24hr )
		let data = this._getData( base, dataSet, d, t, rush24hr, submitted )

		return data
	}

	_getData(base, dataSet, dept, type, rush24hr, submitted) {

		let arr = base.map( a => {
			let key = a.toLowerCase().split('-').join('').split(' ').join('_')

			let label = ( key === 'print' ) ? 'Release' : a
			let offset;

			if (rush24hr && key === 'delivery' ) {
				offset = 1
			} else if (key === 'approval') {
				offset = 0
			} else {
				offset = dataSet[key]
			}

			let adjustedOffset = this._adjustForWorkdays( offset )

			// use submitted date if available, otherwise generate date
			let data = (submitted && key === 'submit')
				? submitted
				: dayjs().add(adjustedOffset, 'day').format('YYYY-MM-DD 00:00:00')

			let prop = this.P ? this.P[key].prop : null

			return {
				cache: Date.now(), // This ensures the data is always few and keep components reactive
				label:label,
				data:data,
				key:key,
				offset:offset,
				adjustedOffset:adjustedOffset,
				prop:prop
			}
		})

		return arr
	}

	_getMilestoneBase (type, premedia, rush24hr) {

		if (rush24hr) {
			return [ 'Submit', 'Approval', 'Delivery' ]
		}
		else if ( type === 'print' && premedia ) {
			return [ 'Submit', 'Approval', 'Pre-Media', 'First Comp', 'Print', 'Delivery' ]
		}
		else if ( type !== 'print' && premedia ) {
			return [ 'Submit', 'Approval', 'Pre-Media', 'First Comp', 'Delivery' ]
		}
		else if ( type === 'print' && !premedia ) {
			return [ 'Submit', 'Approval', 'First Comp', 'Print', 'Delivery' ]
		}
		else {
			return [ 'Submit', 'Approval', 'First Comp', 'Delivery' ]
		}
	}

	_adjustForWorkdays(offset) {

		let today = new Date()
		let dateString
		let count = 0
		let endDate = 0
		let newOffset = 0

		while ( count < offset ) {
			endDate = new Date( today.setDate( today.getDate()+1 ) )
			dateString = endDate.getFullYear() + '-'
						+ ('0' + (endDate.getMonth()+1)).slice(-2) + '-'
						+ ('0' + endDate.getDate()).slice(-2)

			if( endDate.getDay() != 0 &&
				endDate.getDay() != 6 &&
				(this.B.indexOf(dateString)) < 0
			) {
				++count
			}

			++newOffset
		}

		return newOffset
	}

	_getDept (d) { return (d) ? d.name.toLowerCase().split(' ').join('_') : 'other'}
	_getType (t) { return (t) ? t.name.toLowerCase().split(' ').join('_') : 'other'}
}



/* import dayjs from 'dayjs'

export default class MilestoneBuilder {

	constructor(configOffset=null, configBlackout=null) {

		this.O = configOffset
		this.B = configBlackout

		this.P = {
			submit: { prop:'date_submitted' },
			approval: { prop:'date_approved' },
			first_comp: { prop:'date_first_comp' },
			premedia: { prop:'date_premedia' },
			print: { prop:'date_release' },
			delivery: { prop:'date_delivery' }
		}
	}


	getMilestones (dept, type, option=null, premedia=null, rush24hr=null, submitted=null) {

		if (!option) option = 'standard'

		let t = this._getType( type )
		let d = this._getDept( dept )
		let o = option ? option.toLowerCase() : null

		let dataSet = this.O[t]

		let base = this._getMilestoneBase( t, premedia, rush24hr )
		let data = this._getData( base, dataSet, d, t, o, rush24hr, submitted )

		return data
	}


	_getData(base, dataSet, dept, type, option, rush24hr, submitted) {

		let arr = base.map( a => {
			let key = a.toLowerCase().split('-').join('').split(' ').join('_')

			let label = ( key === 'print' ) ? 'Release' : a
			let offset;

			if (rush24hr && key === 'delivery' ) {
				offset = 1
			} else if (key === 'approval') {
				offset = 0
			} else {

			// offset =
			// if (type= print, dept=internationl, (key= delivery or print))
			// 	-> get international data
			// 	else if (dept= international, (key= delivery or premedia or first comp))
			// 	-> get international data
			// 	else get non-internaltionl data


				offset = ((type === 'print') && (dept === 'international') && (key === 'delivery' || key === 'print'))
                    ? dataSet[`${key}_international_${option}`]
                    :  (dept === 'international') && ((key === 'delivery' || key === 'premedia' || key === 'first_comp'))
                        ? dataSet[`${key}_international_${option}`]
                        : dataSet[key]
			}

			let adjustedOffset = this._adjustForWorkdays( offset )

			// use submitted date if available, otherwise generate date
			let data = (submitted && key === 'submit')
				? submitted
				: dayjs().add(adjustedOffset, 'day').format('YYYY-MM-DD 00:00:00')

			let prop = this.P ? this.P[key].prop : null

			return {
				cache: Date.now(), // This ensures the data is always few and keep components reactive
				label:label,
				data:data,
				key:key,
				offset:offset,
				adjustedOffset:adjustedOffset,
				prop:prop
			}
		})

		return arr
	}


	_getMilestoneBase (type, premedia, rush24hr) {

		if (rush24hr) {
			return [ 'Submit', 'Approval', 'Delivery' ]
		}
		else if ( type === 'print' && premedia ) {
			return [ 'Submit', 'Approval', 'Pre-Media', 'First Comp', 'Print', 'Delivery' ]
		}
		else if ( type !== 'print' && premedia ) {
			return [ 'Submit', 'Approval', 'Pre-Media', 'First Comp', 'Delivery' ]
		}
		else if ( type === 'print' && !premedia ) {
			return [ 'Submit', 'Approval', 'First Comp', 'Print', 'Delivery' ]
		}
		else {
			return [ 'Submit', 'Approval', 'First Comp', 'Delivery' ]
		}
	}


	_adjustForWorkdays(offset) {

		let today = new Date()
		let dateString
		let count = 0
		let endDate = 0
		let newOffset =0

		while ( count < offset ) {
			endDate = new Date( today.setDate( today.getDate()+1 ) )
			dateString = endDate.getFullYear() + '-'
						+ ('0' + (endDate.getMonth()+1)).slice(-2) + '-'
						+ ('0' + endDate.getDate()).slice(-2)

			if( endDate.getDay() != 0 &&
				endDate.getDay() != 6 &&
				(this.B.indexOf(dateString)) < 0
			) {
				++count
			}

			++newOffset
		}

		return newOffset
	}


	_getDept (d) { return (d) ? d.name.toLowerCase().split(' ').join('_') : 'other'}
	_getType (t) { return (t) ? t.name.toLowerCase().split(' ').join('_') : 'other'}
}
 */
